import CustomModal from "../CustomModal";
import { useLocations } from "../../../hooks/useLocations";

const AddStaffModal = ({
  isOpen,
  onRequestClose,
  formData,
  handleChange,
  handleSubmit,
  imagePreviewUrl,
}) => {
  const { locations, loading: loadingLocations, currentAdminRoleId } = useLocations(isOpen);
  
  // Only show Super Admin option if current admin is Super Admin (role_id = 3)
  const canCreateSuperAdmin = currentAdminRoleId === 3;

  const handleLocationChange = (e) => {
    const locationId = parseInt(e.target.value, 10);
    handleChange({ target: { name: "location_id", value: locationId } });
  };

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Add Staff Modal"
      className="add-admin-modal"
    >
      <div className="add-staff-head">
        <h2>Staff details</h2>
      </div>

      <div className="add-staff-image">
        <div className="add-staff-image-pic">
          {imagePreviewUrl ? (
            <img
              src={imagePreviewUrl}
              alt="Selected"
              width="36px"
              height="36px"
            />
          ) : (
            <img
              src={`${process.env.PUBLIC_URL}/images/upload-img.png`}
              alt="Upload image placeholder"
              width="36px"
              height="36px"
            />
          )}
          <div className="add-staff-image-text">
            <p>Upload staff's picture</p>
            <p>PNG OR JPG</p>
          </div>
        </div>
        <input
          type="file"
          accept="image/png, image/jpeg, image/jpg"
          id="upload-picture"
          name="profile_image"
          onChange={handleChange}
          style={{ display: "none" }}
        />
        <label htmlFor="upload-picture" style={{ cursor: "pointer" }}>
          Upload picture
        </label>
      </div>

      <form onSubmit={handleSubmit} className="staff-form">
        <div className="inner-form">
          <label htmlFor="f_name">First Name:</label>
          <br />
          <input
            type="text"
            id="f_name"
            name="f_name"
            value={formData.f_name}
            onChange={handleChange}
            required
          />

          <label htmlFor="l_name">Last Name:</label>
          <br />
          <input
            type="text"
            id="l_name"
            name="l_name"
            value={formData.l_name}
            onChange={handleChange}
            required
          />

          <label htmlFor="address">Address:</label>
          <br />
          <input
            type="text"
            id="address"
            name="address"
            value={formData.address}
            onChange={handleChange}
            required
          />

          <label htmlFor="email">Email:</label>
          <br />
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <label htmlFor="phone">Phone Number:</label>
          <br />
          <input
            type="tel"
            id="phone"
            name="phone"
            pattern="[0-9]{11}"
            value={formData.phone}
            onChange={handleChange}
            required
          />

          <label htmlFor="nin">National Identification Number:</label>
          <br />
          <input
            type="text"
            id="nin"
            name="nin"
            value={formData.nin}
            onChange={handleChange}
            required
          />

          <label htmlFor="location_id">Location:</label>
          <br />
          <select
            id="location_id"
            name="location_id"
            value={formData.location_id || ''}
            onChange={handleLocationChange}
            required
            disabled={loadingLocations}
          >
            <option value="" disabled>
              {loadingLocations ? 'Loading locations...' : 'Select a location'}
            </option>
            {locations.map(loc => (
              <option key={loc.id} value={loc.id}>{loc.name}</option>
            ))}
          </select>

          <label htmlFor="role_id">Role:</label>
          <br />
          <select
            id="role_id"
            name="role_id"
            value={formData.role_id}
            onChange={handleChange}
            required
          >
            <option value="2">Admin</option>
            {canCreateSuperAdmin && (
              <option value="4">Branch Admin</option>
            )}
            {canCreateSuperAdmin && (
              <option value="3">Super Admin</option>
            )}
          </select>
        </div>
        <div className="modal-button">
          <button type="button" onClick={onRequestClose}>
            Cancel
          </button>
          <input type="submit" value="Submit" />
        </div>
      </form>
    </CustomModal>
  );
};

export default AddStaffModal;
